module.exports = "tr.td-data-table-row {\n  height: 120px; }\n\n.HandCursor {\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/consulta/tecnicasdiagnosticas/tecnicasdiagnosticas.component.scss
// module id = ./src/app/consulta/tecnicasdiagnosticas/tecnicasdiagnosticas.component.scss
// module chunks = main